import { formatDate, toTimeOnlyString } from '@/lib/display'

export const formatInterviewDateTime = (interview, dateFormatter = formatDate, timeFormatter = toTimeOnlyString) => {
  if (!interview.date) {
    return ''
  }

  const date = dateFormatter(interview.date)
  const startTime = interview.start_DateTime ? timeFormatter(interview.start_DateTime) : ''
  const endTime = interview.end_DateTime ? timeFormatter(interview.end_DateTime) : ''
  const timeRange = startTime && endTime
    ? `${startTime} - ${endTime}`
    : startTime || endTime

  return timeRange ? `${date} ${timeRange}` : date
}
